// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"d88296adf50510b0","931":"79830ab156cf89e2"}[chunkId] + ".css";
};